import { Loader } from "lucide-react";

import { useLoadingAction } from "@/components/hooks/useLoadingAction";
import { Button as BaseButton } from "@/components/ui/button";
import { cn } from "@/lib/utils";

import type { ReactNode } from "react";
import type { ButtonProps } from "@/components/ui/button";

interface LoadingButtonProps extends Omit<ButtonProps, "onClick"> {
  onClick: () => void | Promise<void>;
  children: ReactNode;
  loaderClassName?: string;
}

const LoadingButton = ({
  onClick,
  children,
  disabled,
  loaderClassName,
  startIcon,
  endIcon,
  ...props
}: LoadingButtonProps) => {
  const { isLoading, executeWithLoading } = useLoadingAction();

  const handleClick = (): void => {
    executeWithLoading(onClick);
  };

  return (
    <BaseButton
      onClick={handleClick}
      disabled={isLoading || disabled}
      startIcon={isLoading && startIcon ? <span className="invisible">{startIcon}</span> : startIcon}
      endIcon={isLoading && endIcon ? <span className="invisible">{endIcon}</span> : endIcon}
      {...props}
      className={cn("relative", props.className)}
    >
      {isLoading ? (
        <>
          <span className="invisible">{children}</span>
          <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <Loader className={cn("size-5 animate-spin", loaderClassName)} />
          </span>
        </>
      ) : (
        children
      )}
    </BaseButton>
  );
};

export default LoadingButton;
